import React from 'react'
import PropTypes from "prop-types";
import { merge } from 'lodash';
import { defaultUser } from '@utils/recordHelpers';

import { PolarisFormProvider } from '@container';

import { UserSellerForm  } from '@presentational';

const propTypes = {
  user: PropTypes.object.isRequired,
  location: PropTypes.string.isRequired,
  update: PropTypes.bool,
  isSeller: PropTypes.bool,
  submitURL: PropTypes.string.isRequired,
};

const defaultProps = {
  update: false,
}

const UserSellerFormWrapper = (props) => {
  const userProps = {...props.user, seller: props.seller};
  const defaultValues = props.update ? userProps : merge(userProps, defaultUser);
  const method = props.update ? "PATCH" : "POST";

  const handleValuesConstruction = (values, formikBag) => {
    let formData = values;
    if(values.seller && values.seller.id){
      formData = { ...formData, seller_attributes: values.seller };
    }
    return formData;
  }

  return(
    <PolarisFormProvider
        title={ I18n.t("activerecord.models.user.one") }
        defaultValues={ defaultValues }
        submitURL={ props.submitURL }
        submitMethod={ method }
        extraValues={{
          is_seller: props.isSeller
        }}
        pickValuesCallback={ handleValuesConstruction }
    >
      { (renderProps) =>
          <div>
            <UserSellerForm
                isSeller={ props.isSeller }
                location={ props.location }
                {...renderProps}
            />
          </div>
      }
    </PolarisFormProvider>
  )
}

UserSellerFormWrapper.proptypes = propTypes;
UserSellerFormWrapper.defaultProps = defaultProps;

export default UserSellerFormWrapper;